/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingModuleRoleName } from '../models/HousingModuleRoleName';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingModuleRolesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get the housing module roles for the current user across all orgs. This is used to determine what permissions the user has in the UI.
     * @returns HousingModuleRoleName OK
     * @throws ApiError
     */
    public getMyHousingModuleRoles(): CancelablePromise<Record<string, Array<HousingModuleRoleName>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingModuleRoles/GetMyHousingModuleRoles',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the housing module roles for all users in a sysOrg. Only users with a role in the sysOrg can view this,
     * and they will only see roles for users in the same sysOrg.
     * @param sysOrgGuid
     * @returns HousingModuleRoleName OK
     * @throws ApiError
     */
    public getHousingModuleRoles(
        sysOrgGuid: string,
    ): CancelablePromise<Record<string, Array<HousingModuleRoleName>>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingModuleRoles/{sysOrgGuid}/GetHousingModuleRoles',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update the housing module roles for a user in a sysOrg. This will overwrite all existing roles for the user in the sysOrg.
     * Only users with UserAdmin role in the sysOrg can do this.
     * @param sysOrgGuid
     * @param userGuid
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public updateHousingModuleRoles(
        sysOrgGuid: string,
        userGuid: string,
        requestBody?: Array<HousingModuleRoleName>,
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingModuleRoles/{sysOrgGuid}/{userGuid}/UpdateHousingModuleRoles',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'userGuid': userGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
